<template>
	<div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;" >
		<!-- 头部 -->
		<div class="titleView">
			<el-row>
				<el-col :span="5" v-if="detailData.add_info">操作人: {{detailData.add_info.add_user_info.user_name}}</el-col>
				<el-col :span="5" v-if="detailData.add_info">申请日期: {{sqDate}}</el-col>
				<el-col :span="5" v-if="detailData.otherInfo">采购数量: {{detailData.otherInfo.procureTotal}}</el-col>
				<el-col :span="5" v-if="detailData.otherInfo">总价: {{detailData.otherInfo.priceTotal.toFixed(2)}}</el-col>
				<el-col :span="4">
					<el-button type="warning" @click="handleBackClick" size="small">返回</el-button>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 20px;">
				<el-col>申请批次号: {{ids}}</el-col>
			</el-row>
			<el-row>
				<el-col>关联门店: {{storeNames}}</el-col>
			</el-row>
		</div>
		<!-- tab切换 -->
		<div class="tabs">
			<el-button @click="handleTabClick(-1)" :type="tabIndex == -1?'warning':''" size="small">全部</el-button>
			<el-button v-for="(item,index) in storeTab" :key="index" @click="handleTabClick(index)" :type="tabIndex == index?'warning':''" size="small">{{item}}</el-button>
		</div>
		<div class="scrollView" style="overflow-y: scroll;">
			<!-- 商品类 -->
			<div class="shopClass" v-if="shops.length > 0">
				<div class="comH2" @click="handleShopClick">
					<div>商品类</div>
					<i class="el-icon-caret-bottom" v-if="showShop"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showShop">
					<el-table ref="multipleTable1" :data="shops" tooltip-effect="dark" size="small">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220"/>
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">采</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120" />
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.add_type == 1">{{scope.row.goods_count}}</span>
								<el-input-number v-model="scope.row.goods_count" controls-position="right" :min="1" :max="1000" style="width:100px" @change="handleCountChange(scope.row)" v-else />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" />
						<el-table-column :key="7" label="总价" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.goods_count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{shopCount}}件</div>
						<div>合计：{{shopPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 医疗类 -->
			<div class="shopClass" v-if="drugs.length > 0">
				<div class="comH2" @click="handleDrugClick">
					<div>医疗类</div>
					<i class="el-icon-caret-bottom" v-if="showDrug"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showDrug">
					<el-table ref="multipleTable2" :data="drugs" tooltip-effect="dark" style="overflow:initial" size="small">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220"/>
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120">
							<template slot-scope="scope">
								{{scope.row.goods.sku_value == ''?'--':scope.row.goods.sku_value}}
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.add_type == 1">{{scope.row.goods_count}}</span>
								<el-input-number v-model="scope.row.goods_count" controls-position="right" :min="1" :max="1000" style="width:100px" @change="handleCountChange(scope.row)" v-else />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" />
						<el-table-column :key="7" label="总价" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.goods_count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{drugCount}}件</div>
						<div>合计：{{drugPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
			<!-- 耗材类 -->
			<div class="shopClass" v-if="haocais.length > 0">
				<div class="comH2" @click="handleHaocaiClick">
					<div>耗材类</div>
					<i class="el-icon-caret-bottom" v-if="showHaocai"></i>
					<i class="el-icon-caret-top" v-else></i>
				</div>
				<div class="tableWarp" v-if="showHaocai">
					<el-table ref="multipleTable2" :data="haocais" tooltip-effect="dark" style="overflow:initial" size="small">
						<el-table-column :key="1" prop="goods.title" label="商品名称" width="220"/>
						<el-table-column :key="11" width="50">
							<template slot-scope="scope">
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">新</el-tag>
								<el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
							</template>
						</el-table-column>
						<el-table-column :key="2" prop="goods.brand" label="品牌" align="center">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="3" prop="goods.sku_value" label="规格" align="center" width="120">
							<template>
								<span>--</span>
							</template>
						</el-table-column>
						<el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
						<el-table-column :key="4" prop="count" label="数量" align="center">
							<template slot-scope="scope">
								<span v-if="scope.row.add_type == 1">{{scope.row.goods_count}}</span>
								<el-input-number v-model="scope.row.goods_count" controls-position="right" :min="1" :max="1000" style="width:100px" @change="handleCountChange(scope.row)" v-else />
							</template>
						</el-table-column>
						<el-table-column :key="6" prop="goods.pprice" label="售价" align="center" />
						<el-table-column :key="7" label="总价" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.goods_count * scope.row.goods.pprice}}</span>
							</template>
						</el-table-column>
						<el-table-column :key="8" prop="shop_stock" label="库存" align="center" width="80">
							<template slot-scope="scope">
								<el-popover placement="right" width="200" trigger="click">
									<template v-if="scope.row.shop_stock.length > 0">
										<div v-for="(item,index) in scope.row.shop_stock" :key="index">{{item.shop_name}}:{{item.shop_stock}}</div>
									</template>
									<div v-else>无库存</div>
									<div slot="reference">库存<span class="el-icon-view" style="color: #0000FF;" /></div>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :key="10" fixed="right" label="操作" align="center" width="160" />
					</el-table>
					<div class="allNum">
						<div>共{{haocaiCount}}件</div>
						<div>合计：{{haocaiPrice.toFixed(2)}}</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 底部按钮 -->
		<div class="fix_btn">
			<el-button type="warning" @click="handlePurchaseClick" size="small">发起采购</el-button>
		</div>
	</div>
</template>
<script>
	import {
		single,
		previewByRequestAsync,
		addbyrequest
	} from '@/api/purchaseApi.js'
	import caigouFilter from '@/util/caigouFilter.js'
	export default {
		data() {
			return {
				shopList: [],
				fixedHeight: '',
				id: JSON.parse(this.$route.query.id), //跳转订单id
				detailData: {}, //订单详情
				allPrice: 0, //商品总价
				sqDate: '', //申请时间
				shops: [], //商品类
				drugs: [], //药品类
				haocais: [], //耗材类
				showShop: true, //显示商品类
				showDrug: true, //显示药品类
				showHaocai: true, //显示耗材类
				shopCount: 0,
				shopPrice: 0,
				drugCount: 0,
				drugPrice: 0,
				haocaiCount: 0,
				haocaiPrice: 0,
				dialogAddGoods_state: false, //商品弹框状态
				stockVisible:false,  //库存
				shopStocks:[],
				addGoodsType:false,  //商品弹框状态   false是添加商品  true是更换
				ids:'',   //id集合
				storeNames:'',  //门店名字集合
				storeTab:[], //门店tab切换
				tabIndex:-1,  //tab默认
				storeGoods:[],  //门店数据集合
				addShops:[],  //新增商品集合
				addShopId:[],  //商品Id集合
			}
		},
		mounted() {
			console.log(this.id,'this.id');
			this.fixedHeight = document.documentElement.clientHeight - 76;
			let addGoods = [];
			this.getDetailData(addGoods)
			let idStr = '';
			for(let i = 0;i<this.id.length;i++){ 
				idStr += (this.id[i]+' ')
			}
			this.ids = idStr
		},
		methods: {
			//返回按钮
			handleBackClick(){
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
					let storage = window.sessionStorage
					storage.setItem("tabs",2)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			//发起采购按钮
			handlePurchaseClick(){
				this.$confirm('是否发起此次采购','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log('商品详情',this.id,this.addShops)
					let parmars = {
						remarks:'',
						procure_request_no_list:this.id,
						add_procure_goods_list:this.addShops
					}
					addbyrequest(parmars).then((res)=>{
						console.log('发起采购',res)
						if(res.code == 0){
							this.$message({
								type: 'success',
								message: '已发起采购'
							});
							let query = {
								id:res.data.procure_no,
								cgtabs:1
							}
							this.$store.commit("setCurNavIndex_caigou",{title:'采购列表',path:'/caigou/cgzDetail'})
							this.$router.push({path:'cgzDetail',query})
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '暂不发起'
					});          
				});
			},
			//tab切换
			handleTabClick(index){
				console.log(index)
				this.tabIndex = index;
				//点击全部
				if(index == -1){
					this.getDetailData()
				}else{  //点击非全部
					this.getStoreData(index)
				}
			},
			//门店数据整合
			getStoreData(index){
				console.log('门店下标',index);
				console.log('门店数据',this.storeGoods)
				let storeGoods = this.storeGoods;
				console.log('当前门店信息',storeGoods[index])
				let detail = storeGoods[index];
				let shopList = []; //商品列表
				let drugList = []; //药品列表
				let haocaiList =[];  //耗材列表
				//循环总商品信息
				for (let i = 0; i < detail.procureGoodsList.length; i++) {
					let parmars = {
						goodsId:detail.procureGoodsList[i].goods._id,
						zt:i
					}
					if(detail.procure_goods_list[i].goods.goods_type == '0'){
						parmars.skuId = detail.procure_goods_list[i].goods.sku_id
					}else{
						parmars.skuId = '';
					}
					//获取库存
					single(parmars).then((resolve)=>{
						console.log(resolve)
						if(resolve.code == 0){
							if(resolve.data == null){
								detail.procure_goods_list[i].shop_stock = [];
							}else{
								detail.procure_goods_list[i].shop_stock = resolve.data.skuList[0].shop_stock;
							}
							if (detail.procureGoodsList[i].goods.goods_type == 1 && (detail.procureGoodsList[i].procure_goods_state == 1 ||detail.procureGoodsList[i].procure_goods_state == 2 || detail.procureGoodsList[i].procure_goods_state == 4)) {
								shopList[i] = detail.procureGoodsList[i]
							} else if (detail.procureGoodsList[i].goods.goods_type == 2 && (detail.procureGoodsList[i].procure_goods_state == 1 ||detail.procureGoodsList[i].procure_goods_state == 2 || detail.procureGoodsList[i].procure_goods_state == 4)) {
								drugList[i] = detail.procureGoodsList[i]
							}else if(detail.procure_goods_list[i].goods.goods_type == 7 && (detail.procure_goods_list[i].procure_goods_state == 1 ||detail.procure_goods_list[i].procure_goods_state == 2 || detail.procure_goods_list[i].procure_goods_state == 4)){
								haocaiList[i] = detail.procure_goods_list[i]
							}
							this.shops = shopList.filter(item=>item);
							this.drugs = drugList.filter(item=>item);
							this.haocais = haocaiList.filter(item=>item);
							this.getAllData()
						}
					}).catch(err=>{
						console.log(err)
					})
				}
			},
			//修改新增数量
			handleCountChange(row) {
				// console.log(this.addShops,row.goods_count,row.goods._id)
				for(let i = 0;i<this.addShops.length;i++){
					if(this.addShops[i].goods._id == row.goods._id){
						this.addShops[i].goods_count = row.goods_count
					}
				}
			},
			//删除新增商品
			handleDeleteClick(row){
				for(let i = 0;i<this.addShops.length;i++){
					if(this.addShops[i].goods._id == row.goods._id){
						console.log('重复')
						this.addShops.splice(i,1)
					}
				}
				this.getDetailData(this.addShops)
			},
			//展开商品类
			handleShopClick() {
				this.showShop = !this.showShop
			},
			//展开药品类
			handleDrugClick() {
				this.showDrug = !this.showDrug
			},
			//展开耗材类
			handleHaocaiClick(){
				this.showHaocai = !this.showHaocai
			},
			//获取总详情
			getDetailData(addGoods) {
				// console.log(addGoods)
				let parmars = {
					remarks : '',
					procure_request_no_list:this.id,   //id集合
					add_procure_goods_list:addGoods
				}
				previewByRequestAsync(parmars).then((res) => {
					if (res.code == 0) {
						console.log('商品详情',res.data)
						this.detailData = res.data;
						let detail = res.data;
						let shopList = []; //商品列表
						let drugList = []; //药品列表
						let haocaiList = [];  //耗材列表
						let storeName = '';  //门店名字
						let idArr = [];  //商品id集合
						this.storeGoods = detail.procureRequestLinkDatas;//门店信息赋值
						
						//循环总商品信息
						for (let i = 0; i < detail.procure_goods_list.length; i++) {
							idArr.push(detail.procure_goods_list[i].goods._id)
							
							let parmars = {
								goodsId:detail.procure_goods_list[i].goods._id,
								zt:i
							}
							if(detail.procure_goods_list[i].goods.goods_type == '0'){
								parmars.skuId = detail.procure_goods_list[i].goods.sku_id
							}else{
								parmars.skuId = '';
							}
							//获取库存
							single(parmars).then((resolve)=>{
								console.log(resolve)
								if(resolve.code == 0){
									if(resolve.data == null){
										detail.procure_goods_list[i].shop_stock = [];
									}else{
										detail.procure_goods_list[i].shop_stock = resolve.data.skuList[0].shop_stock;
									}
									if (detail.procure_goods_list[i].goods.goods_type == 0 && (detail.procure_goods_list[i].procure_goods_state == 1 ||detail.procure_goods_list[i].procure_goods_state == 2 || detail.procure_goods_list[i].procure_goods_state == 4)) {
										shopList[i] = detail.procure_goods_list[i]
									} else if (detail.procure_goods_list[i].goods.goods_type == 1 && (detail.procure_goods_list[i].procure_goods_state == 1 ||detail.procure_goods_list[i].procure_goods_state == 2 || detail.procure_goods_list[i].procure_goods_state == 4)) {
										drugList[i] = detail.procure_goods_list[i]
									}else if(detail.procure_goods_list[i].goods.goods_type == 7 && (detail.procure_goods_list[i].procure_goods_state == 1 ||detail.procure_goods_list[i].procure_goods_state == 2 || detail.procure_goods_list[i].procure_goods_state == 4)){
										haocaiList[i] = detail.procure_goods_list[i]
									}
									this.sqDate = caigouFilter.timestampToDate(detail.add_info.create_time)
									this.shops = shopList.filter(item=>item);
									this.drugs = drugList.filter(item=>item);
									this.haocais = haocaiList.filter(item=>item);
									this.getAllData()
								}
							}).catch(err=>{
								console.log(err)
							})
						}
						//上传所有商品id
						this.addShopId = idArr;
						// console.log(detail.procureRequestLinkDatas)
						//获取门店信息
						let storeList = detail.procureRequestLinkDatas;
						let storeArr = [];
						for(let j = 0;j < storeList.length;j++){
							let storeStr = '';
							switch(storeList[j].companyInfo.shop_id){
								case '5e9412e0b2bfbc089daerr12':
									storeStr = '金水区店';
									break;
								case '5e9412e0b2bfbc089daerr14':
									storeStr = '指挥中心店';
									break;
								case '5e9412e0b2bfbc089daerr17':
									storeStr = '线上旗舰店';
									break;
								case '5e9412e0b2bfbc089daerr18':
									storeStr = '郑东新区店';
									break;
								case '5e9412e0b2bfbc089daerr10':
									storeArr.push('驯养中心 ');
									break;
								case '5e9412e0b2bfbc089daerr11':
									storeArr.push('小程序 ');
									break;
							}
							storeName += (storeStr + ' ')
							storeArr.push(storeStr)
						}
						// console.log(storeName)
						this.storeNames = storeName;
						this.storeTab = storeArr;
					}
				})
			},
			// 获取合计
			getAllData() {
				// console.log('商品列表', this.shops)
				// console.log('药品列表', this.drugs)
				let shops = this.shops;
				let drugs = this.drugs;
				let haocais = this.haocais;
				let shopCount = 0;
				let shopPrice = 0;
				let drugCount = 0;
				let drugPrice = 0;
				let haocaiCount = 0;
				let haocaiPrice = 0;
				if (shops.length > 0) {
					for (let i = 0; i < shops.length; i++) {
						// console.log(shops[i].count)
						shopCount = (shopCount + shops[i].goods_count);
						shopPrice = (shopPrice + shops[i].goods_count * shops[i].goods.pprice)
					}
					this.shopCount = shopCount;
					this.shopPrice = shopPrice;
				}
				if (drugs.length > 0) {
					for (let j = 0; j < drugs.length; j++) {
						drugCount = (drugCount + drugs[j].goods_count);
						drugPrice = (drugPrice + drugs[j].goods_count * drugs[j].goods.pprice)
					}
					this.drugCount = drugCount;
					this.drugPrice = drugPrice
				}
				if (haocais.length > 0) {
					for (let k = 0; k < haocais.length; k++) {
						haocaiCount = (haocaiCount + haocais[k].goods_count);
						haocaiPrice = (haocaiPrice + haocais[k].goods_count * haocais[k].goods.pprice)
					}
					this.haocaiCount = haocaiCount;
					this.haocaiPrice = haocaiPrice
				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
		// 重复头部
		.titleView {
			width: 99%;
			padding: 20px 0;
			padding-left: 10px;
			margin: 0 auto;
			font-size: 14px;
			color: #2A2A2A;
			background: #fff;
			border-radius: 6px;
		}
		.scrollView{
			flex: 1;
		}
		.scrollView::-webkit-scrollbar {
			display: none;
		}
		//重复标题
		.comH2 {
			line-height: 64px;
			font-size: 18px;
			display: flex;
			align-items: center;
		}

		.comH2 div {
			margin-left: 20px;
			margin-right: 6px;
			font-weight: bold;
		}

		.comH2 img {
			width: 16px;
			height: 16px;
			background: red;
		}

		.tableWarp {
			border-radius: 6px;
			background: #fff;
			padding: 20px 30px;

			.tableName {
				line-height: 46px;
				background: #F7F6F9;
				font-size: 18px;
				color: #2A2A2A;
				font-weight: bold;
				margin-bottom: 10px;
			}

			.allNum {
				font-size: 14px;
				background: #F5F5F5;
				height: 50px;
				display: flex;
				align-items: center;
				padding-left: 20px;

				div:nth-of-type(1) {
					margin-right: 20px;
				}
			}
		}

		.fix_btn {
			width: 100%;
			height: 72px;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			button {
				margin-right: 30px;
			}

			button:nth-of-type(5) {
				margin-right: 60px;
			}
		}
		.tabs{
			margin: 10px 0;
		}
	}
</style>
